import { useMemo } from 'react';
import { useUserRole } from './useUserRole';

/**
 * Hook to check user permissions for navigation and UI elements
 * @returns {Object} Object with permission checking functions
 */
export const useNavigationPermissions = () => {
    const { canAccessAdmin } = useUserRole();

    return useMemo(() => ({
        /**
         * Check if a navigation item should be visible
         * @param {Object} item - Navigation item with optional for_admin property
         * @returns {boolean}
         */
        canViewNavItem: (item) => {
            if (item.for_admin) {
                return canAccessAdmin;
            }
            return true;
        },

        /**
         * Filter navigation items based on user permissions
         * @param {Array} items - Array of navigation items
         * @returns {Array} Filtered navigation items
         */
        filterNavItems: (items) => {
            return items.filter(item => {
                if (item.for_admin) {
                    return canAccessAdmin;
                }
                return true;
            });
        },

        // Direct access to admin status
        canAccessAdmin
    }), [canAccessAdmin]);
};

export default useNavigationPermissions;
